/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { getColor } from 'utils';
import styled, { withTheme } from 'styled-components';

const ShadowsEnabledSVG = styled('svg')`
  color: ${props => props.color || getColor(props, 'onPrimary')};
`;

const ShadowsEnabledOutlined = withTheme(props => {
  const { theme, width, height, color } = props;
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;

  return (
    <ShadowsEnabledSVG
      theme={theme}
      $selectedTheme={selectedTheme}
      width={width || 32}
      height={height || 32}
      color={color}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 15 15'
      fill='none'
    >
      <g fill='currentColor' fillRule='evenodd' clipRule='evenodd'>
        <path d='M6.783 13.376c1.956-3.423 1.956-8.329 0-11.752l.434-.248c2.044 3.577 2.044 8.671 0 12.248l-.434-.248Z' opacity='.05' />
        <path d='M7.282 13.477c1.957-3.482 1.957-8.472 0-11.955l.436-.244c2.043 3.634 2.043 8.81 0 12.444l-.436-.245Z' opacity='.1' />
        <path d='M7.821 13.506c1.904-3.51 1.905-8.492.004-12.005l.44-.238c1.981 3.662 1.98 8.822-.004 12.482l-.44-.239Z' opacity='.15' />
        <path d='M8.413 13.429c1.782-3.5 1.783-8.354.001-11.855l.446-.227c1.854 3.644 1.853 8.666-.002 12.309l-.445-.227Z' opacity='.2' />
        <path d='M9.024 13.296c1.633-3.458 1.635-8.119.006-11.58l.452-.212c1.693 3.595 1.69 8.412-.005 12.005l-.453-.213Z' opacity='.25' />
        <path d='M9.668 13.066c1.442-3.37 1.443-7.754.003-11.125l.46-.196c1.493 3.496 1.492 8.022-.003 11.517l-.46-.197Z' opacity='.3' />
        <path d='M10.331 12.746c1.224-3.225 1.225-7.255.004-10.482l.467-.177c1.265 3.341 1.264 7.497-.003 10.836l-.468-.177Z' opacity='.35' />
        <path d='M11.015 12.299c.979-3.002.98-6.586.003-9.588l.476-.155c1.009 3.103 1.008 6.796-.003 9.898l-.476-.155Z' opacity='.4' />
        <path d='M11.721 11.668c.704-2.655.705-5.671.003-8.327l.483-.128c.725 2.74.724 5.844-.002 8.583l-.484-.128Z' opacity='.45' />
        <path d='M12.443 10.752c.41-2.114.41-4.391 0-6.505l.49-.095a17.888 17.888 0 0 1 .001 6.695l-.49-.095Z' opacity='.5' />
        <path d='M7.5.877a6.623 6.623 0 0 0-5.023 10.94l-.83.83a.5.5 0 1 0 .707.707l.83-.83a6.623 6.623 0 0 0 9.34-9.34l.83-.83a.5.5 0 0 0-.707-.708l-.83.83A6.597 6.597 0 0 0 7.5.878Zm3.642 2.274a5.673 5.673 0 0 0-7.992 7.992l7.992-7.992Zm-7.284 8.698a5.673 5.673 0 0 0 7.991-7.992L3.858 11.85Z' />
      </g>
    </ShadowsEnabledSVG>
  );
});

export { ShadowsEnabledOutlined };